module.exports = {
      id: "environment-usage",
      viewBox: "0 0 28.781 28.787",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#environment",
      toString: function () {
        return this.url;
      }
    }